import { SVGProps, Ref, forwardRef } from 'react';

export const Diagram100Size16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.714 4.185c-.806.967-1.18 2.327-1.18 3.815s.374 2.848 1.18 3.815c.773.928 2.075 1.652 4.286 1.652 2.212 0 3.513-.724 4.287-1.652.805-.967 1.18-2.327 1.18-3.815s-.375-2.848-1.18-3.815C11.513 3.256 10.212 2.533 8 2.533s-3.513.723-4.286 1.652M8 1.333C3 1.333 1.334 4.667 1.334 8S3 14.667 8 14.667 14.667 11.333 14.667 8 13 1.333 8 1.333"
                fill="currentColor"
            />
        </g>
    </svg>
));
Diagram100Size16Glyph.displayName = 'Diagram100Size16Glyph';
